import * as React from "react";
import { useRef } from "react";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import MessageBulkActions, { MessageBulkActionsModal } from "search/MessageBulkActions";
const BulkActions = () => {
  const addEvidenceModalRef = useRef(null);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkActionsDropdown, { bsSize: "xs" }, /* @__PURE__ */ React.createElement(MessageBulkActions, { modalRef: () => addEvidenceModalRef.current })), /* @__PURE__ */ React.createElement(
    MessageBulkActionsModal,
    {
      ref: (r) => {
        addEvidenceModalRef.current = r;
      }
    }
  ));
};
export default BulkActions;
